import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';

import Container from '../../components/Layout/Container';
import PageTopBanner from '../../components/PageTopBanner';

import { TabsLink } from '../../components/Tab/Tabs';
import { technicalIntroData } from '../../components/Tab/TabData';

import { Button, PageControlBtns } from '../../components/Button/Button';

import ToggleLanguage from '../../components/ToggleLanguage';

import Modal, { useToggleModal } from '../../components/Modal/Modal';
import { Player } from 'react-tuby';
import 'react-tuby/css/main.css';
import { fetchGet } from '../../hooks/fetch';
import { getTokenPayload, getUserToken } from '../../hooks/useLogin';
import { DownloadLink } from '../../utils/DownloadFunctions';
import { GroupTypes } from './PlatformEums';
import Loading from '../Loading';
import useSearch from '../../hooks/useSearch';

export default function PlatformPatentDetail() {
	const navigate = useNavigate();
	const { id } = useParams();

	const [activeTab, setActiveTab] = useState('');
	const [post, setPost] = useState();
	const [isLoading, setIsLoading] = useState(true);
	const [isLogin, setIsLogin] = useState(false);

	const pageName = 'Patent';

	/**
	 * URL 기반 상태
	 * - 상세 URL에는 page/searchText가 없더라도
	 *   이전 목록 URL 기준으로 history에 유지됨
	 */
	const {
		page,
		searchText,
		language,
		updateParams,
	} = useSearch({
		defaultLanguage: 'ko',
	}, 'patent');

	/** 상세 조회 */
	useEffect(() => {
		if (!id) return;
		setIsLoading(true);

		fetchGet(
			`/platform/patent/${id}?language=${language}`,
			(json) => {
				setPost(json);
				setIsLoading(false);
			}
		);

		if (getUserToken() !== '' && getTokenPayload().id !== 0) {
			setIsLogin(true);
		}
	}, [id, language]);

	
	/**
	 * 목록으로 복귀
	 * - page / searchText 유지
	 * - language는 상세에서 선택한 값 사용
	*/
	const goBackToList = () => {
		navigate(
			`/platform/patent?page=${page}&searchText=${searchText}&language=${language}`,
			{ replace: true }
		);
	};
	
	/** 언어 변경 */
	const handleSelectLanguage = (lang) => {
		updateParams({ language: lang });

		sessionStorage.setItem(
			'patent:lastLanguage',
			lang
		);
	};



	const toggleModal = useToggleModal();

	return (
		<main id="technical-intro-page-wrap" className="map-page">
			<h1 className="sr-only">{`${pageName} 페이지`}</h1>

			<PageTopBanner />

			<Container>
				<TabsLink
					className="sub-page-tab-con"
					tabsData={technicalIntroData}
					activatedTab={activeTab}
					onTabChange={setActiveTab}
				/>

				<div className="page-content">
					<div className="content-top">
						<div>
							<h1 className="title">{pageName}</h1>
						</div>
						<ToggleLanguage index={language} onChange={handleSelectLanguage} />
					</div>

					<div>
						<PageControlBtns isBtn onClick={goBackToList} />
						{post ? (
							<div className="detail-form-con">
								<div className="dv-header">
									<div className="gs-infos-badge">
										<div>
											<span className={`icon-category-${GroupTypes[post?.type]?.class}`}>
												{language === 'ko' ? GroupTypes[post.type]?.str : GroupTypes[post.type]?.enStr}
											</span>
										</div>
										<div className="info-2">
											<h2>{post.name}</h2>
										</div>
										<div className="gs-unit gray">
											<span>{post.representative}</span>
											<span>{post.company}</span>
										</div>
									</div>
								</div>
								<div className="dv-body">
									<div className="list-box">
										{post.items !== undefined && post.items.map(p => {
											return (
												<dl>
													<dt>▶ {p.name}</dt>
													<dd>
														{(p.inputType === "TEXT" || p.inputType === "TEXT_AREA") && 
															p.content?.includes("<")
															? <div dangerouslySetInnerHTML={{ __html: p.content }} />
															: <pre>{p.content}</pre>
														}
														{p.inputType === "FILE" && 
															<ul className="gs-files">
																{ p.files?.map(f => <li><DownloadLink name={f.name} uid={f.uid} /></li>)}
															</ul>
														}
													</dd>
												</dl>
											)
										})}
									</div>
								</div>
							</div>
						) : (
							isLoading ? <Loading /> : <div className="gs-no-con">해당 게시글을 찾을 수 없습니다.</div>
						)}
					</div>

					<PageControlBtns isBtn onClick={goBackToList}>
						{post !== undefined && post.video !== null && (
							<button
								type="button"
								className="gs-btn"
								onClick={() => toggleModal.open({ name: 'check-form-dialog' })}
							>
								동영상 보기
							</button>
						)}
					</PageControlBtns>
				</div>
			</Container>

			{toggleModal.modal?.name === 'check-form-dialog' && !isLogin && (
				<Modal ariaLabelledby="check-form-dialog" handleOpenModal={toggleModal.close} className="dialog">
					<Modal.Header>기술사업화지원센터</Modal.Header>
					<Modal.Body className="center">로그인 후 이용하세요.</Modal.Body>
					<Modal.Footer>
						<Button type="button" className="gray" onClick={toggleModal.close}>
							취소
						</Button>
						<Link to="./../../../account/login" className="gs-btn" onClick={toggleModal.close}>
							<strong>로그인하기</strong>
						</Link>
					</Modal.Footer>
				</Modal>
			)}

			{toggleModal.modal?.name === 'check-form-dialog' && isLogin && (
				<Modal
					ariaLabelledby="check-form-dialog"
					className="video-modal-wrap"
					handleOpenModal={toggleModal.close}
					disableOutsideClick
				>
					<Modal.Body className="center">
						<Player
							src={`/api-tlo/file/image/${post.video}`}
							//poster="https://images.pexels.com/photos/8797157/pexels-photo-8797157.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
						/>
					</Modal.Body>
				</Modal>
			)}
		</main>
	);
}
